import { css, CSSResult } from 'lit'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const style: CSSResult = css`
  .sort-options-mobile {
    display: block;

    @media(min-width: ${SCREENS.medium}) {
      display: none;
    }
  }

  .sort-options-desktop {
    display: none;

    @media(min-width: ${SCREENS.medium}) {
      display: block;
    }
  }
`
